import { create } from "zustand";

interface EnvState {
	isInitialized: boolean;
	initialize: (env: Partial<Omit<EnvState, "initialize">>) => void;

	// GENERAL
	readonly ENV: "test" | "development" | "production";
	readonly SYSTEM_TITLE: string | undefined;
	// API
	readonly API_URL: string | undefined;
	readonly SOCKET_PATH: string | undefined;
	// LINE
	readonly LINE_ADD_FRIEND_URL: string | undefined;
	readonly LINE_QR_URL: string | undefined;
	readonly LINE_LIFF_ACCOUNT_URL: string | undefined;
}

export const useEnvStore = create<EnvState>()((set) => ({
	isInitialized: false,
	initialize: (env) =>
		set((state) => ({ ...state, ...env, isInitialized: true })),

	// GENERAL
	ENV: "development",
	SYSTEM_TITLE: undefined,
	// API
	API_URL: undefined,
	SOCKET_PATH: "/socket.io",
	// LINE
	LINE_ADD_FRIEND_URL: undefined,
	LINE_QR_URL: undefined,
	LINE_LIFF_ACCOUNT_URL: undefined,
}));
